/**
 * AdvisorsPage — `/advisors` (s216, SEO phase 1 item 2).
 *
 * The B2B landing URL. Keyword 21 in the s216 audit ("estate planning tools for financial advisors
 * canada", easy difficulty) had no page to rank: the advisor band was a scroll anchor on "/".
 *
 * Renders the shared `AdvisorSection`, same component as the landing band — see its header for why
 * the ROUTE is deliberately not gated by `SHOW_ADVISOR_BAND`.
 */
import { useLocation } from 'wouter';
import { PublicLayout } from '@/components/public/PublicLayout';
import { AdvisorSection } from '@/components/public/AdvisorSection';
import { Seo } from '@/components/public/Seo';
import { OrganizationStructuredData } from '@/components/public/StructuredData';

export default function AdvisorsPage() {
  const [, navigate] = useLocation();

  return (
    <PublicLayout>
      <Seo path="/advisors" />
      <OrganizationStructuredData />
      <AdvisorSection
        heading="h1"
        onPartner={() => navigate('/contact')}
        // On this page there is no in-page #pricing to scroll to, so "See advisor pricing"
        // goes to the real pricing PAGE rather than scrolling nowhere.
        onSeePricing={() => navigate('/pricing')}
      />
    </PublicLayout>
  );
}
